/**
 * @ngdoc services
 * @memberof mercury.services
 * @name httpBuffer
 * @description
 *    HTTP interceptor service to limit the number of concurrent requests and queue up any additional requests.
 *    Adapted from https://github.com/mikepugh/angular-http-throttler
 */
angular.module('mercury.services.throttleinterceptor', [])
.factory('httpBuffer', function() {
    var buffer;

    buffer = [];

    function append(config, deferred) {
      return buffer.push(deferred);
    }

    function retryOne() {
      var deferred;
      if (buffer.length > 0) {
        deferred = buffer.shift();
        deferred.resolve();
      }
    }

    function purge() {
      buffer = [];
    }

    return {
      purge: purge,
      append: append,
      retryOne: retryOne
    };
  });
